import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import React from 'react';
import { NotificationTypeItem } from '../../../services/NotificationChannel';
import { palette } from '../../../theme';
import { StyledChannelCard, StyledChannelHint } from '../styles';

const NOTIFICATION_TYPE_META: Record<
  string,
  { label: string; hint: string; icon: React.ReactNode }
> = {
  SMS: {
    label: 'SMS',
    hint: 'Receba alertas por mensagem de texto no celular cadastrado.',
    icon: <SmsOutlinedIcon color='primary' />,
  },
  EMAIL: {
    label: 'E-mail',
    hint: 'Receba alertas no endereço de e-mail cadastrado.',
    icon: <EmailOutlinedIcon color='primary' />,
  },
  WHATSAPP: {
    label: 'WhatsApp',
    hint: 'Receba alertas pelo WhatsApp no celular cadastrado.',
    icon: <ChatOutlinedIcon color='primary' />,
  },
};

const getNotificationTypeMeta = (type: string) => {
  return (
    NOTIFICATION_TYPE_META[type] ?? {
      label: type,
      hint: 'Canal de notificação disponível.',
      icon: <SmsOutlinedIcon color='primary' />,
    }
  );
};

type NotificationChannelSelectorProps = {
  notificationTypes: NotificationTypeItem[];
  selectedNotificationTypeId: string;
  loading: boolean;
  onSelect: (typeId: number) => void;
};

export const NotificationChannelSelector: React.FC<
  NotificationChannelSelectorProps
> = ({
  notificationTypes,
  selectedNotificationTypeId,
  loading,
  onSelect,
}) => {
  if (loading && notificationTypes.length === 0) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
        <CircularProgress size={28} color='secondary' />
      </Box>
    );
  }

  return (
    <>
      <Grid container spacing={2} alignItems='stretch'>
        {notificationTypes.map((notificationType) => {
          const meta = getNotificationTypeMeta(notificationType.type);
          const isSelected =
            String(notificationType.id) === selectedNotificationTypeId;

          return (
            <Grid
              item
              xs={12}
              sm={4}
              key={notificationType.id}
              sx={{ display: 'flex' }}
            >
              <StyledChannelCard
                selected={isSelected}
                disabled={loading}
                onClick={() => onSelect(notificationType.id)}
                elevation={0}
              >
                {meta.icon}
                <Typography
                  color={isSelected ? 'secondary' : palette.text.main}
                  fontWeight={isSelected ? 600 : 500}
                >
                  {meta.label}
                </Typography>
                <Typography
                  variant='caption'
                  color={palette.text.main}
                  textAlign='center'
                  sx={{ flex: 1 }}
                >
                  {meta.hint}
                </Typography>
              </StyledChannelCard>
            </Grid>
          );
        })}
      </Grid>
      <StyledChannelHint>
        Ao trocar de canal, enviaremos um código de validação para confirmar a
        alteração.
      </StyledChannelHint>
    </>
  );
};
